import React from 'react';
import styled from '@emotion/styled';
import { BadgeTag } from './BadgeTag';
import CancelIcon from '../../../../../assets/cancel-white.svg?reference';
import { Color } from '../../../shared/styles/Color';
import { useTranslation } from '../../../shared/i18n/translate/useTranslation';

interface ILoyaltyTagProps {
	text: string;
	onClick: () => void;
}

export const CancelBadgeTag = ({ text, onClick }: ILoyaltyTagProps) => {
	const { t } = useTranslation();

	return (
		<StyledBadgeTag text={text}>
			<StyledBadgeButton
				type="button"
				onClick={onClick}
				aria-label={`${t(
					'loyalty_reward_offers_cancel_button_aria_label',
				)} ${text}`}
			>
				<img src={CancelIcon} alt="" />
			</StyledBadgeButton>
		</StyledBadgeTag>
	);
};

export const StyledBadgeTag = styled(BadgeTag)``;

const StyledBadgeButton = styled.button`
	display: flex;
	background: none;
	border: none;
	padding: 0;
	margin-left: 2px;

	&:focus-visible {
		outline: 2px solid ${Color.BackgroundWhite};
		border-radius: 3px;
	}
`;
